module.exports = __webpack_public_path__ + "img/right_5.a11f9b69.jpg";